<template>
  <div class="state-select">
    <vs-row>
      <vs-col>
        <h6>Selecione o estado</h6>
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center" vs-align="flex-start">
      <whole-multiselect
        title="Estado"
        :options="states"
        placeholder="Estado"
        v-model="state"
        :showText="true"
        label="nome"
        class="select"
        @input="sendState()"
      />
    </vs-row>
  </div>
</template>
<script>
import mixins from "@/Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";

export default {
  mixins: [mixins],
  components: {
    WholeMultiselect,
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      states: [],
      stateValue: "",
    };
  },
  props: {
    state: {
      type: Object,
      default() {
        return {
          id: null,
          text: null,
          sigla: null,
        };
      },
      required: false,
    },
    showShortName: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  created() {
    const vm = this;
    vm.getStates();
  },

  watch: {
    state: function () {
      const vm = this;
      vm.stateValue = vm.state;
    },
  },

  methods: {
    getStates() {
      const vm = this;
      vm.axios
        .get(
          "https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome",
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            for (var i in response.data)
              vm.states.push({
                id: response.data[i].id,
                text: vm.showShortName ? response.data[i].sigla : response.data[i].nome,
                sigla: response.data[i].sigla,
              });
          }
        });
    },

    sendState() {
      const vm = this;
      vm.$emit("update-state", vm.state);
      vm.$nextTick(() => {
        vm.removeFocus();
      });
    },

    removeFocus() {
      document.activeElement.blur();
    },

    clearFields() {
      const vm = this;
      vm.$nextTick(() => {
        vm.removeFocus();
      });
    },
  },
};
</script>
<style lang="scss">
.state-select {
  background-color: rgb(243, 240, 240);
  border-radius: 10px;
  margin: 10px 10px 0px 0px !important;
  padding: 20px 40px 20px 20px !important;
  .search {
    margin-top: 40px;
    min-width: 40px;
  }
  .clear {
    margin-left: 10px;
  }
  .vs-input {
    .vs-con-input {
      background-color: white;
    }
  }
}
</style>
